import throttle from 'lodash/throttle';
import { PureComponent } from 'react';
import { Text, View } from 'react-native';

import { AnalyticsEvent } from '../../../constants/AnalyticsEvent';
import { PAY_VALUE_BY_NAME, retryMethodByCard } from '../../../constants/payby';
import { globalNormalDialogProxy } from '../../../elements/Dialog';
import Touchable from '../../../elements/Touchable';
import { translate } from '../../../i18n';
import { PatchTransactionActionsPayload } from '../../../redux/actions/patchTransactionActions';
import { PaymentData as PaymentMethod } from '../../../types/Payment';
import { PaymentData } from '../../../types/TransactionDetail';
import Config from '../../../utils/configs';
import { getIsTW } from '../../../utils/countryInfo';
import * as navigationService from '../../../utils/navigationService';
import styles from './RetryBtn.styles';

interface PropsPaymentData extends PaymentData {
  PAY_NAME: string;
}

interface Props {
  paymentData: PropsPaymentData;
  transactionID: string;
  patchTransaction: (payload: PatchTransactionActionsPayload) => void;
  setDirectPayModalState: Function;
  hasMultipleCard: boolean;
  logEvent: Function;
  makeCheckoutMethodRaw: PaymentMethod;
}

export default class RetryBtn extends PureComponent<Props> {
  onPressRetryATM = () => {
    const { transactionID, patchTransaction, logEvent } = this.props;

    logEvent({ logEvent: AnalyticsEvent.CreditCardRepayAtm, transactionID });
    patchTransaction({
      pay_by: PAY_VALUE_BY_NAME.SINOPAC_VIRTUAL_ACCOUNT,
      transactionID,
      failure: error => {
        globalNormalDialogProxy.open({
          positiveText: translate('alert-default-positive-text'),
          contentText: translate(
            `patch-transaction-error-text.${error.data.error_code}`,
            {
              defaultValue: translate('patch-transaction-default-error'),
            }
          ),
        });
      },
    });
  };

  onPressRetryCard = () => {
    const {
      paymentData,
      setDirectPayModalState,
      logEvent,
      transactionID,
      patchTransaction,
    } = this.props;
    // 檢查可刷卡的方式
    const retryMethod = retryMethodByCard(paymentData.PAY_NAME);

    if (retryMethod.length) {
      logEvent({ logEvent: AnalyticsEvent.CreditCardRepay, transactionID });

      // TAPPAY 不能用的信用卡付款備案
      if (retryMethod === 'CREDIT_CARD') {
        if (paymentData.PAY_NAME !== retryMethod) {
          patchTransaction({
            pay_by: PAY_VALUE_BY_NAME[retryMethod],
            transactionID,
            failure: error => {
              globalNormalDialogProxy.open({
                positiveText: translate('alert-default-positive-text'),
                contentText: translate(
                  `patch-transaction-error-text.${error.data.error_code}`,
                  {
                    defaultValue: translate('patch-transaction-default-error'),
                  }
                ),
              });
            },
          });
        }
        const url = `${Config.REACT_APP_WEB_VIEW_URL}/card/auth/${transactionID}?no_header=1&no_footer=1`;

        navigationService.navigate('WebViewPage', {
          title: translate('creditCardPaymentPage'),
          needCookie: true,
          url,
          transactionID,
          isCancelBtn: true,
          // set it true to check 3d otp password for direct-pay
          handleWebviewMessage: true,
          screenViewName: 'payment_cc',
        });
      } else {
        setDirectPayModalState(true);
      }
    }
  };
  _throttleOnPressRetryATM = throttle(this.onPressRetryATM, 500);
  _throttleOnPressRetryCard = throttle(this.onPressRetryCard, 500);

  static isPayByCard(payBy: number) {
    return (
      payBy === PAY_VALUE_BY_NAME.CREDIT_CARD ||
      payBy === PAY_VALUE_BY_NAME.CARD_LINK ||
      payBy === PAY_VALUE_BY_NAME.DIRECT_PAY_PRIME ||
      payBy === PAY_VALUE_BY_NAME.DIRECT_PAY_TOKEN
    );
  }

  isAtmMaintain() {
    const { makeCheckoutMethodRaw } = this.props;

    return !Object.keys(makeCheckoutMethodRaw).includes(
      PAY_VALUE_BY_NAME.SINOPAC_VIRTUAL_ACCOUNT.toString()
    );
  }

  render() {
    const { pay_by } = this.props.paymentData;

    return (
      <>
        <View style={styles.retryContainer}>
          {getIsTW() && (
            <Touchable
              accessibilityRole="button"
              style={[
                styles.retryBtn,
                { marginRight: 10 },
                this.isAtmMaintain() && styles.disable,
              ]}
              onPress={this._throttleOnPressRetryATM}
              testID="retry-atm"
              disabled={this.isAtmMaintain()}
            >
              <Text style={styles.retryText}>
                {translate('orderDetail-retry-atm')}
              </Text>
            </Touchable>
          )}
          <Touchable
            accessibilityRole="button"
            style={[styles.retryBtn]}
            onPress={this._throttleOnPressRetryCard}
          >
            <Text style={styles.retryText}>
              {RetryBtn.isPayByCard(pay_by)
                ? translate('orderDetail-retry-card')
                : translate('orderDetail-use-card')}
            </Text>
          </Touchable>
        </View>
        {getIsTW() && this.isAtmMaintain() && (
          <Text style={styles.atmMaintain}>
            {translate('atm-maintaining-pay-by-other')}
          </Text>
        )}
      </>
    );
  }
}
